// extracted by mini-css-extract-plugin
export var activityContainer = "_l7-0";
export var typingIndicatorContainer = "_l7-1";
export var typingIndicatorDot = "_l7-2";
export var wave = "_l7-3";